import { Component } from '@angular/core';
import { ToastService } from './services/toast/toast.service';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';

import { close } from 'ionicons/icons';
import { addIcons } from 'ionicons';
import { VERSION } from 'src/version.const';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {
  constructor(
    private swUpdate: SwUpdate,
    private toast: ToastService,
    private router: Router
  ) {
    console.log(VERSION);
    addIcons({close});
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((v) => {
        if (v.type == 'VERSION_READY') {
          this.toast.logWithButton('Доступна новая версия', 'Обновить', () => {
            window.location.reload();
          });
        }
      });
    }
  }

  onNotfy(data: any) {
    if (!data.tap) {
      this.toast.log(data.title + '. ' + data.body, 2000);
    } else {
      if (data && data.reserveId) {
        this.router.navigate(['admin', 'reserve', data.reserveId]);
      }
    }
  }
}
